import { __rest } from "tslib";
/* eslint-disable react/no-array-index-key */
import * as React from 'react';
import classNames from 'classnames';
import FloatButton, { floatButtonPrefixCls } from './FloatButton';
import FloatButtonGroup from './FloatButtonGroup';
import BackTop from './BackTop';
import { ConfigContext } from '../config-provider';
const PureFloatButton = (_a) => {
    var { backTop } = _a, props = __rest(_a, ["backTop"]);
    return backTop ? React.createElement(BackTop, Object.assign({}, props, { visibilityHeight: 0 })) : React.createElement(FloatButton, Object.assign({}, props));
};
function PurePanel(_a) {
    var { className, items } = _a, props = __rest(_a, ["className", "items"]);
    const { prefixCls: customizePrefixCls } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls(floatButtonPrefixCls, customizePrefixCls);
    const pureCls = `${prefixCls}-pure`;
    if (items) {
        return (React.createElement(FloatButtonGroup, Object.assign({ className: classNames(className, pureCls) }, props), items.map((item, index) => (React.createElement(PureFloatButton, Object.assign({ key: index }, item))))));
    }
    return React.createElement(PureFloatButton, Object.assign({ className: classNames(className, pureCls) }, props));
}
export default React.memo(PurePanel);
